import React from 'react';
import useStyles from '../ServiceWarrantyPage.styles';
import {Typography} from '@material-ui/core';
import Faq from 'components/Faq';
import Content from 'components/Content';

export default function () {
    let classes = useStyles();

    return (
        <>
            <Faq
                title="I have a complaint"
            >
                <Content className={classes['__content']}>
                    <Typography
                        variant="body2"
                        component="p"
                    >
                        Coming soon
                    </Typography>
                </Content>
            </Faq>
            <Faq
                title="How long do you provide support for the delivered work?"
            >
                <Content className={classes['__content']}>
                    <Typography
                        variant="body2"
                        component="p"
                    >
                        Coming soon
                    </Typography>
                </Content>
            </Faq>
            <Faq
                title="How do I communicate changes to you?"
            >
                <Content className={classes['__content']}>
                    <Typography
                        variant="body2"
                        component="p"
                    >
                        Coming soon
                    </Typography>
                </Content>
            </Faq>
        </>
    );
};
